<template>
  <div
    class="d-flex flex-column align-center justify-center"
    style="height: 75vh"
  >
    <v-icon size="32" color="blue-grey lighten-1" class="mb-3">
      mdi-view-column-outline
    </v-icon>
    <p class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-1 mb-1">
      {{ title }}
    </p>
    <p
      class="ma-0 pa-0 caption blue-grey--text mb-5 text-center"
      style="max-width: 300px"
    >
      {{ subtitle }}
    </p>
    <v-btn
      v-if="!shared"
      color="blue"
      rounded
      class="white--text"
      elevation="0"
      data-tourid="boards-emptyState-createButton"
      @click="$emit('createBoard')"
      >{{ $t('boards.create_new_board') }}</v-btn
    >
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    shared: Boolean,
  },

  computed: {
    title() {
      return this.shared
        ? this.$t('boards.shared_empty_state_title')
        : this.$t('boards.empty_state_title')
    },

    subtitle() {
      return this.shared
        ? this.$t('boards.shared_empty_state_subtitle')
        : this.$t('boards.empty_state_subtitle')
    },
  },
}
</script>
